<section class="component-tab component-faq">
	<div class="wrapper">
		<div class="row">
			<div class="col-12 col-md-9">
				<div class="faq" *ngIf="faqContent != ''">
					<h2 *ngIf="faqBlockTitle" [innerHtml]="faqBlockTitle"></h2>
					<div class="accordion">
						<div class="accordion__repeater" *ngFor="let faq of faqContent">
							<h3 class="accordion__controller" (click)="accordion( $event, 'accordion__opened' )">
								<span [innerHtml]="faq.inner_question"></span><i class="icon-breadcrumb-bottom"></i>
							</h3>
							<div class="accordion__content" [innerHtml]="faq.inner_answer">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>